import { c as _c } from "react/compiler-runtime";
import { USER_PAGE_ACTIVITY_TAB } from "../UserPageActivityWrapper";
export default function UserPageActivityTab(t0) {
  const $ = _c(8);
  const {
    tab,
    activeTab,
    setActiveTab
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [USER_PAGE_ACTIVITY_TAB.WALLET_ACTIVITY]: "Wallet Activity",
      [USER_PAGE_ACTIVITY_TAB.DISTRIBUTIONS]: "Distributions",
      [USER_PAGE_ACTIVITY_TAB.TDH_HISTORY]: "TDH History"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const TAB_TO_LABEL = t1;
  const t2 = `tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-border tw-border-solid tw-border-iron-700 tw-transition tw-duration-300 tw-ease-out ${tab === activeTab ? "tw-bg-iron-800 tw-text-iron-100" : "tw-bg-iron-950 hover:tw-bg-iron-900 tw-text-iron-500 hover:tw-text-iron-100"} ${tab === USER_PAGE_ACTIVITY_TAB.WALLET_ACTIVITY && "tw-rounded-l-lg"} ${tab === USER_PAGE_ACTIVITY_TAB.TDH_HISTORY && "tw-rounded-r-lg"}`;
  let t3;
  if ($[1] !== setActiveTab || $[2] !== tab) {
    t3 = () => setActiveTab(tab);
    $[1] = setActiveTab;
    $[2] = tab;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = TAB_TO_LABEL[tab];
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <button type="button" className={t2} onClick={t3}>{t4}</button>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}